import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

const MAX_FILES = 5;

const formatBytes = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const SupportUploader = ({ files, onChange, maxFiles = MAX_FILES }) => {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  const totalSize = files.reduce((sum, f) => sum + (f.size || 0), 0);

  const handleSelect = (e) => {
    const selected = Array.from(e.target.files || []);
    const combined = [...files, ...selected].slice(0, maxFiles);
    onChange(combined);
    e.target.value = "";
  };

  const removeFile = (index) => {
    onChange(files.filter((_, i) => i !== index));
  };

  return (
    <div>
      {files.length > 0 && (
        <div className="d-flex flex-wrap gap-2 mb-2">
          {files.map((file, i) => {
            const previewUrl = URL.createObjectURL(file);
            return (
              <div
                key={i}
                className="position-relative"
                style={{ width: 64, height: 64 }}
              >
                <img
                  src={previewUrl}
                  alt={file.name}
                  style={{
                    width: 64,
                    height: 64,
                    objectFit: "cover",
                    borderRadius: 6,
                    border: "1px solid #dee2e6",
                  }}
                  onLoad={() => URL.revokeObjectURL(previewUrl)}
                />
                <button
                  type="button"
                  onClick={() => removeFile(i)}
                  className="position-absolute top-0 end-0 btn btn-sm p-0 d-flex align-items-center justify-content-center"
                  style={{
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    background: "rgba(0,0,0,0.55)",
                    color: "#fff",
                    fontSize: 10,
                    lineHeight: 1,
                    border: "none",
                    transform: "translate(30%, -30%)",
                  }}
                  aria-label="Remove"
                >
                  ×
                </button>
              </div>
            );
          })}
        </div>
      )}

      <div className="d-flex align-items-center gap-2">
        <label
          htmlFor="support-file-input"
          className="btn btn-outline-secondary btn-sm mb-0"
          style={{ cursor: files.length >= maxFiles ? "not-allowed" : "pointer", opacity: files.length >= maxFiles ? 0.5 : 1 }}
        >
          <i className="fas fa-paperclip me-1" />
          {t("support.attach_file")}
          {files.length > 0 && ` (${files.length}/${maxFiles})`}
        </label>

        {files.length > 0 && (
          <span className="text-muted" style={{ fontSize: "0.78rem" }}>
            {formatBytes(totalSize)}
          </span>
        )}
      </div>

      <input
        ref={inputRef}
        id="support-file-input"
        type="file"
        accept="image/*"
        multiple
        disabled={files.length >= maxFiles}
        onChange={handleSelect}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default SupportUploader;
